<div class="row">
  <div class="col-md-12">
    <h5>
      {{ 'Site.TlsParameters' | translate }}
    </h5>
  </div>
</div>
<div *ngIf="availableTlsOptions.length == 0">{{ 'TlsOptions.noneAvailable' | translate }}</div>
<ng-container *ngIf="availableTlsOptions.length > 0" class="row tls-options">
  <div class="row mx-lg-n3 separator">
    <div class="col-xxl-6 px-lg-3">
      <div class="row form-group">
        <app-label class="col" label="TlsOptions.siteLabel" />
        <div class="col-xl-6">
          <ng-select
            [(ngModel)]="config.tlsOptions"
            [placeholder]="'NoOption' | translate"
            [items]="availableTlsOptions"
            [addTag]="false"
            bindLabel="name"
            name="tlsOptions"
            appendTo="body"
          />
        </div>
      </div>
    </div>
    <div class="col-xxl-6 px-lg-3">
      <div class="row form-group">
        <app-label class="col" label="Site.passTlsClientCert.label" />
        <div class="col-xl-6">
          <select
            [(ngModel)]="config.passTlsClientCert"
            name="passTlsClientCert"
            [disabled]="!config.tlsOptions"
            class="form-control"
          >
            <option *ngFor="let x of PassTlsClientCerts" [value]="x">
              {{ 'PassTlsClientCert.' + x | translate }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="btn-container">
        <button (click)="saveTlsOptions()" class="btn btn-sm btn-primary">{{ 'valider' | translate }}</button>
      </div>
    </div>
  </div>
</ng-container>
